import * as XLSX from "xlsx";

export const REQUIRED_TICKET_UPLOAD_HEADERS = [
  "agentname",
  "accountno",
];

export const OPTIONAL_TICKET_UPLOAD_HEADERS = [
  "outstanding",
  "paymentdate",
  "remarks",
  "calllogid",
];

export const normalizeHeader = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

export const getMissingRequiredHeaders = (headers = []) => {
  const normalized = headers.map(normalizeHeader);
  return REQUIRED_TICKET_UPLOAD_HEADERS.filter((header) => !normalized.includes(header));
};

export const parseCsvHeaders = (text) => {
  const firstLine = String(text || "").split(/\r?\n/)[0] || "";
  return firstLine
    .split(",")
    .map((item) => item.replace(/^"|"$/g, "").trim())
    .filter(Boolean);
};

export const readUploadHeaders = async (file) => {
  const fileName = file?.name?.toLowerCase() || "";
  if (fileName.endsWith(".csv")) {
    const text = await file.text();
    return parseCsvHeaders(text);
  }

  const fileBuffer = await file.arrayBuffer();
  const workbook = XLSX.read(fileBuffer, { type: "array" });
  const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
  return Array.isArray(rows?.[0]) ? rows[0] : [];
};
